<!-- The user guide page is formatted using vue-simple-accordion -->
<!-- Ref link for vue-simple-accordion: https://developer.aliyun.com/mirror/npm/package/vue-simple-accordion/v/0.0.1?spm=a2c6h.14275010.0.0.5b183b77r1qw2f&file=0.0.1 -->
<template>
<div class="showscroll">
  <h1>User Guide</h1>
  <body>
    <vsa-list>
      <vsa-item>
        <vsa-heading>How do I get started?</vsa-heading>
        <vsa-content>
          <div>
            <vsa-list class="vsa-list-light">
              <vsa-item>
                <vsa-heading>Step 1: Input the SQL query</vsa-heading>
                <vsa-content>
                  <div>
                    <ul>
                      <li>
                        Input the SQL query in the
                        <i>SQL query panel</i> (Figure 1) or select a SQL in the
                        <i>Example</i> query.
                      </li>
                      <li>
                        Click the
                        <strong>Submit</strong> button.
                      </li>
                    </ul>
                    <figure class="center">
                      <img src="@/assets/imgs/sqlquery.png" alt="sqlquery" />
                      <figcaption>Figure 1: Input SQL query.</figcaption>
                    </figure>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Step 2: Analyze QEP</vsa-heading>
                <vsa-content>
                  <div>
                    <ul>
                      <li>
                        The QEP for the input SQL query will be displayed in the
                        <i>QEP panel</i> and
                        <i>Visualize plan panel</i> (Figure 2) in natural language and tree form.
                      </li>
                      <li>
                        Hover over the node of visualized operator tree to check the natural language description of the operator (Figure 2), Or click
                        <strong>Detailed view</strong> to see the full view.
                      </li>
                      <li>
                        Click the
                        <strong>Compare</strong> button to visualize the differences of
                        <strong>RULE-LANTERN</strong> and
                        <strong>NEURAL-LANTERN</strong> output (Figure 3 and Figure 4).
                      </li>
                    </ul>
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/qeppanel.png" alt="qeppanel" />
                        <figcaption>Figure 2: QEP panel.</figcaption>
                      </figure>
                    </div>
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/compare.png" alt="compare" />
                        <figcaption>Figure 3: Compare button.</figcaption>
                        <img src="@/assets/imgs/compare_view.png" alt="compareview" />
                        <figcaption>
                          Figure 4: The differences of
                          <strong>RULE-LANTERN</strong> and
                          <strong>NEURAL-LANTERN</strong> output.
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Step 3: Ask a question regarding the QEP</vsa-heading>
                <vsa-content>
                  <div>
                    <ul>
                      <a>
                        <strong>The Q&A module provided by NEURON</strong>
                      </a>
                      <li>
                        Choose your question into the
                        <i>question panel</i> (Figure 4).
                      </li>
                      <li>
                        Click the
                        <strong>Submit</strong> button. The answer will be displayed in the
                        <i>answer panel</i> (Figure 5).
                      </li>
                      <li>
                        Click the
                        <strong>Submit</strong> button to leave a feedback (Figure 9) on the
                        <i>LANTERN</i> system to help us improve it.
                      </li>
                    </ul>
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/question.png" alt="question" />
                        <figcaption>Figure 4: Question panel.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/answer.png" alt="answer" />
                        <figcaption>Figure 5: Answer panel.</figcaption>
                      </figure>
                    </div>
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/feedback.png" alt="feedback" />
                        <figcaption>Figure 6: Q&A feedback.</figcaption>
                      </figure>
                      <figure class="column center"></figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
            </vsa-list>
          </div>
        </vsa-content>
      </vsa-item>
      <!-- <vsa-item>
        <vsa-heading>What types of questions can I ask LANTERN?</vsa-heading>
        <vsa-content>
          <div>
            <vsa-list class="vsa-list-light">
              <vsa-item>
                <vsa-heading>Define concept</vsa-heading>
                <vsa-content>
                  <div>
                    Questions related to definitions of various SQL keywords and query plan operators (e.g.,
                    <i>Index Only Scan</i>)
                    <br />
                    <br />
                    <strong>Example:</strong>
                    <br />
                    <i>Question:</i> What is the index only scan? (Figure 7)
                    <br />
                    <i>Answer:</i> An index only scan scans an index on the table. The is used when the index contains all columns
                    required in the query. (Figure 8)
                    <br />
                    <br />
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/conceptquestion.png" alt="conceptquestion" />
                        <figcaption>Figure 7: Question on concept definition.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/conceptanswer.png" alt="conceptanswer" />
                        <figcaption>Figure 8: Answer for question in Figure 7.</figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Find number of tuples generated at specific step</vsa-heading>
                <vsa-content>
                  <div>
                    NEURON can report the number of tuples (rows) left after a certain step.
                    <br />
                    <br />
                    <strong>Note:</strong> Questions in the form of
                    <i>number of rows left after joining relations A and B</i> (i.e., without step identifier)
                    are
                    <strong>not supported</strong> as two or more joins on same relations but different columns may be performed in a single query, leading to ambiguity.
                    <br />
                    <br />
                    <strong>Example:</strong>
                    <br />
                    <i>Question:</i> How many rows are left after Step 2? (Figure 9)
                    <br />
                    <i>Answer:</i> There are 1264432 row(s) left. (Figure 10)
                    <br />
                    <br />
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/rowquestion.png" alt="rowquestion" />
                        <figcaption>Figure 9: Question on number of tuples.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/rowanswer.png" alt="rowanswer" />
                        <figcaption>Figure 10: Answer for question in Figure 12.</figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Find list of operators used to evaluate a query</vsa-heading>
                <vsa-content>
                  <div>
                    NEURON can provide the list of distinct opertors used in a QEP.
                    <br />
                    <br />
                    <strong>Example:</strong>
                    <br />
                    <i>Question:</i> What operators are used? (Figure 11)
                    <br />
                    <i>Answer:</i> The operators used are Aggregate, Sort, Hash Semi Join, Gather, Merge, Hash,
                    Seq Scan, and Limit. (Figure 12)
                    <br />
                    <br />
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/question.png" alt="question" />
                        <figcaption>Figure 11: Question on operator list.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/answer.png" alt="answer" />
                        <figcaption>Figure 12: Answer for question in Figure 11.</figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Find amount of time taken by specific step in the QEP</vsa-heading>
                <vsa-content>
                  <div>
                    Questions related to amount of time needed for a specific time, which is calculated bsaed on the
                    <i>Actual Total Time</i>
                    element of the corresponding node and its children in the operator tree.
                    <br />
                    <br />
                    <strong>Example:</strong>
                    <br />
                    <i>Question:</i> How long does step 1 takes? (Figure 13)
                    <br />
                    <i>Answer:</i> Step 1 took 338.819 milliseconds to finish. (Figure 14)
                    <br />
                    <br />
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/timequestion.png" alt="timequestion" />
                        <figcaption>Figure 13: Question on time of specific step.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/timeanswer.png" alt="timeanswer" />
                        <figcaption>Figure 14: Answer for question in Figure 13.</figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
              <vsa-item>
                <vsa-heading>Find dominant (i.e., most expensive) operation in the QEP</vsa-heading>
                <vsa-content>
                  <div>
                    NEURON uses the total time taken by each step to determine the most expensive operation (i.e., longest time taken) in a QEP.
                    <br />
                    <br />
                    <strong>Example:</strong>
                    <br />
                    <i>Question:</i> What is the most expensive step? (Figure 14)
                    <br />
                    <i>Answer:</i> Step 2 is the most expensive operation, it took 1855.007 milliseconds to finish. (Figure 15)
                    <br />
                    <br />
                    <div class="row">
                      <figure class="column center">
                        <img src="@/assets/imgs/timequestion.png" alt="timequestion" />
                        <figcaption>Figure 14: Question on most expensive operation.</figcaption>
                      </figure>
                      <figure class="column center">
                        <img src="@/assets/imgs/timeanswer.png" alt="timeanswer" />
                        <figcaption>Figure 15: Answer for question in Figure 14.</figcaption>
                      </figure>
                    </div>
                  </div>
                </vsa-content>
              </vsa-item>
            </vsa-list>
          </div>
        </vsa-content>
      </vsa-item>-->
      <vsa-item>
        <vsa-heading>How do I switch between datasets?</vsa-heading>
        <vsa-content>
          <div class="indented">
            Click on
            <strong>Switch DB</strong> button (Figure 7). The database schema would be updated to that of the current selected dataset upon successful switching.
            <figure class="center">
              <img src="@/assets/imgs/switchdb.png" alt="switchdb" />
              <figcaption>Figure 7: Switch DB button.</figcaption>
            </figure>
          </div>
        </vsa-content>
      </vsa-item>
    </vsa-list>
    <!-- router -->
    <router-view></router-view>
  </body>
</div>
</template>
<script>
import { VsaList, VsaItem, VsaHeading, VsaContent } from 'vue-simple-accordion'
//import '@/assets/css/vue-simple-accordion.css';
import 'vue-simple-accordion/dist/vue-simple-accordion.css'
export default {
  name: 'Datasets',
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  }
}
</script>